import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/artigos/page.tsx");
